import { selector } from 'recoil'

import { bankOptions } from '@/shared/constants'
import {
  otpAuthType,
  otpCryptoNumber,
  otpPNumber,
  otpTelecom,
  otpTransctionID,
} from '@/shared/recoil/otp/atom'

import {
  refundAgreeRefund,
  refundBankContentsType,
  refundBantAccount,
  refundCapthca,
  refundUName,
} from './atom'

export const withCaptchaForm = selector<Omit<RequestRefundOtpBody, 'AuthToken'>>({
  key: 'withCaptchaForm',
  get: ({ get }) => {
    return {
      Telecom: get(otpTelecom),
      CaptchaTransID: get(refundCapthca).CaptchaID,
      PNumber: get(otpPNumber),
      AuthType: get(otpAuthType),
      PCode: 'autocall_homepage',
    }
  },
})

const withReqRefundData = selector<ReqRefundData>({
  key: 'withReqRefundData',
  get: ({ get }) => {
    return {
      BankName: bankOptions.find((opt) => opt.value === get(refundBankContentsType))?.label ?? '',
      Accountnumber: get(refundBantAccount),
      AccountName: get(refundUName),
      TermsAgree: get(refundAgreeRefund) === 0 ? false : true,
    }
  },
})

export const withRefundForm = selector<RequestRefundRegistBody>({
  key: 'withRefundForm',
  get: ({ get }) => {
    return {
      Telecom: get(otpTelecom),
      CaptchaTransID: get(refundCapthca).CaptchaID,
      PNumber: get(otpPNumber),
      TransactionID: get(otpTransctionID),
      CryptoNumber: get(otpCryptoNumber),
      PCode: 'autocall_homepage',
      ReqRefundData: get(withReqRefundData),
    }
  },
})
